import React from 'react';
import classNames from 'classnames';

import { Footer } from '../../components/footer';
import { SeoSection } from '../../components/seo';

import Line from '../../img/line.svg';
import Tape from '../../img/tape-info.webp';
import Paper from '../../img/paper.webp';
import PaperBlue from '../../img/paper-blue.webp';
import Device from '../../img/device-2.webp';
import PaperYellow from '../../img/paper-yellow.webp';
import PaperSmall from '../../img/paper-small.webp';
import Percent from '../../img/percent.webp';

import * as styles from './index.module.scss';

export const Info = () => (
  <section className={styles.info}>
    <div className={styles.line}>
      <img src={Line} alt="Line" />
    </div>
    <div className="container">
      <div className={styles.wrap}>
        <div className={styles.header}>
          <div className={styles.tape}>
            <img src={Tape} alt="Tape" />
          </div>
          <h2 className={styles.head}>
            <span className="nowrap">В приложении</span> тебя ждет
          </h2>
        </div>
        <div className={styles.columns}>
          <div className={styles.column}>
            <div className={classNames(styles.card, styles.cardDevice)}>
              <div className={styles.img}>
                <img src={Paper} className={styles.paper} alt="Paper" />
                <img src={PaperBlue} className={styles.paperBlue} alt="Paper Blue" />
                <img src={Device} className={styles.device} alt="Device" />
              </div>
              <div className={styles.cardDeviceContent}>
                <h3 className={styles.title}>Большой выбор матчей</h3>
                <p className={styles.text}>
                  Принимаем ставки на&nbsp;турниры со&nbsp;всего мира, а&nbsp;также предлагаем
                  варианты ставок, которые сложно найти у&nbsp;других
                </p>
              </div>
            </div>
          </div>
          <div className={styles.column}>
            <div className={classNames(styles.card, styles.cardPercent)}>
              <h3 className={styles.title}>Выгодные коэффициенты каждый день</h3>
              <p className={styles.text}>
                На&nbsp;самые популярные матчи мы&nbsp;повышаем коэффициенты. Заходи&nbsp;&mdash;
                проверяй
              </p>
              <img src={PaperYellow} className={styles.paperYellow} alt="Paper Yellow" />
              <img src={PaperSmall} className={styles.paperSmall} alt="Paper Small" />
              <img src={Percent} className={styles.percent} alt="Percent" />
            </div>
            <div className={styles.card}>
              <h3 className={styles.title}>Выиграл&nbsp;&mdash; деньги сразу у&nbsp;тебя</h3>
              <p className={styles.text}>
                Моментальный расчет ставки и&nbsp;зачисление выигрыша на&nbsp;карту или кошелёк
              </p>
            </div>
          </div>
        </div>
      </div>

      <SeoSection />
    </div>

    <Footer />
  </section>
);
